/* eslint-disable */
var baseApiUrl = ''
var appBaseUrl = ''
if (process.env.NODE_ENV === 'production') {
  // baseApiUrl = 'https://commenting-tool-demo-api-v2.geodemosolutions.com/public/'
  // appBaseUrl = 'https://commenting-tool-demo-v2.geodemosolutions.com/#/'
  baseApiUrl = 'https://gehbi-commenting-tool-api.geodemosolutions.com/public/'
  appBaseUrl = 'https://gehbi-commenting-tool.geodemosolutions.com/#/'
 }
else {
  baseApiUrl = 'http://localhost/gehbi-commenting-tool-api/public/'
  appBaseUrl = 'http://localhost:2200/#/'
}

export {
  baseApiUrl,
  appBaseUrl
}
